import { render, staticRenderFns } from "./CardInfoText.vue?vue&type=template&id=467878a6&scoped=true&"
import script from "./CardInfoText.vue?vue&type=script&lang=js&"
export * from "./CardInfoText.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoText.vue?vue&type=style&index=0&id=467878a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467878a6",
  null
  
)

export default component.exports